$(document).ready(function() {
	$('img[usemap]').imageMap();
});